import React from 'react'
import SuperUserLoanPageSF from '../../../templates/SuperUserLoanPageSF.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import ProjectSF from '../../../components/superUser/loan/ProjectSF'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'

const ProjectPageUI = ({ context, errorList, loan, onRefreshClick }) =>
  <SuperUserLoanPageSF context={context} className='pg_su_loan_project'
    backLink={`/su/loans${loan && (loan.status === 'closed' ? '/closed' : (loan.status === 'disbursed' ? '/disbursed' : ''))}`}
    headerText={loan ? (loan.accountName + ' ' + (loan.loanName || '')) : 'Loan'}
    centered={!loan || !errorList} loan={loan} page='project' dimension='w1600'
  >
    {
      (!loan || !errorList) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      loan &&
      <ProjectSF context={context} loan={loan} onRefreshClick={onRefreshClick} />
    }
  </SuperUserLoanPageSF>

export default ProjectPageUI
